import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const PlotList = ({ newPlot }) => {
  const [plots, setPlots] = useState([])
  const [loading, setLoading] = useState(false)
  const [siteNames, setSiteNames] = useState([])
  const [selectedSite, setSelectedSite] = useState('')

  const buttonStyle = {
    transition: 'transform 0.3s ease',
  }
  const buttonHoverstyle = {
    transform: 'scale(1.2)',
  }
  const [isHovered, setIsHovered] = useState(false)
  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      window.location.href = '/login'
    }
  }, [])

  useEffect(() => {
    const fetchSites = async () => {
      setLoading(true)
      const token = Cookies.get('authToken')

      try {
        const response = await axios.get(
          BASE_URL+'/sites',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        setSiteNames(response.data.data)
      } catch (error) {
        toast.error('Failed to fetch sites')
      } finally {
        setLoading(false)
      }
    }
    fetchSites()
  }, [])

  const fetchPlots = async (siteId = '') => {
    setLoading(true)
    const token = Cookies.get('authToken')

    try {
      const url = siteId
        ? BASE_URL+`/plot/search?site_id=${siteId}`
        : BASE_URL+'/plot/search'

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      setPlots(response.data.data || [])
    } catch (err) {
      toast.error(err.response?.data?.message || 'No Plots are available')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPlots()
  }, [])

  const handleSiteSelect = (e) => {
    const siteId = e.target.value
    setSelectedSite(siteId)
    fetchPlots(siteId)
  }

  return (
  <Container className="pb-3" style={{fontFamily: theme.font.family }}>

          <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>

          <Row>
            <Col
              className="text-start mb-3 p-2 rounded-2"
              style={{   }}
            >
              <Form.Label
                htmlFor="site_name"
                style={{
                  color: theme.colors.primary,
                  // marginBottom: '0.5rem',
                  // fontSize: '16px',
                
                  // letterSpacing: '3px',
                  fontWeight: 'bold',
                }}
              >
                Select Site Name
              </Form.Label>
              <Form.Select
                // className="shadow-lg"
                id="site_name"
                name="site_name"
                onChange={handleSiteSelect}
                value={selectedSite}
              >
                <option value="">All Sites</option>
                {siteNames.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          </div>
        <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>

          <Table
            bordered
            hover
            responsive="md"
            className="text-center table table-bordered table-hover"
          >
            <thead className="position-sticky top-0 text-start">
                <tr className="text-start">
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Status</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Size</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Name</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Is Corner</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Number</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Block</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
                </tr>
                
            </thead>
            <tbody className="text-start">
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    Loading plots...
                  </td>
                </tr>
              ) : plots.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-danger">
                    No plots are available
                  </td>
                </tr>
              ) : (
                plots.map((plot) => (
                  <tr key={plot.id}>
                    <td>{plot.status}</td>
                    <td>{plot.plot_size}</td>
                    <td>{plot.name}</td>
                    <td>{plot.is_corner}</td>
                    <td>{plot.plot_number}</td>
                    <td>{plot.block}</td>
                    <td>
                      {/* Updation using a particular user by given its ID */}
                      <Link
                        to={`/updateplot/${plot.id}`}
                        className="btn btn-outline-success btn-sm me-4"
                        title="Edit Plot"
                        style={
                          isHovered === plot.id
                            ? { ...buttonStyle, ...buttonHoverstyle }
                            : buttonStyle
                        }
                        onMouseEnter={() => setIsHovered(plot.id)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        
        </div>
    </Container>
  )
}

export default PlotList
